/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowInputs */

const th_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตาม`)
};

const en_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow`)
};

const ja_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー`)
};

const zh_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注`)
};

const es_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir`)
};

const pt_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir`)
};

const id_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti`)
};

const fr_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre`)
};

const tl_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sundan`)
};

const vi_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi`)
};

const ko_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔로우`)
};

const de_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgen`)
};

const ru_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться`)
};

const tr_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip et`)
};

const it_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segui`)
};

const pl_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwuj`)
};

const uk_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стежити`)
};

const hi_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉलो करें`)
};

const ar_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متابعة`)
};

const ms_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti`)
};

const bn_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুসরণ`)
};

const zh_tw2_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤`)
};

const zh_hk2_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤`)
};

const ur_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فالو کریں`)
};

const fa_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دنبال کردن`)
};

const sw_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuatilia`)
};

const nl_follow = /** @type {(inputs: FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgen`)
};

/**
* | output |
* | --- |
* | "Follow" |
*
* @param {FollowInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const follow = /** @type {((inputs?: FollowInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_follow(inputs)
	if (locale === "ja") return ja_follow(inputs)
	if (locale === "zh") return zh_follow(inputs)
	if (locale === "es") return es_follow(inputs)
	if (locale === "pt") return pt_follow(inputs)
	if (locale === "id") return id_follow(inputs)
	if (locale === "fr") return fr_follow(inputs)
	if (locale === "tl") return tl_follow(inputs)
	if (locale === "vi") return vi_follow(inputs)
	if (locale === "ko") return ko_follow(inputs)
	if (locale === "de") return de_follow(inputs)
	if (locale === "ru") return ru_follow(inputs)
	if (locale === "tr") return tr_follow(inputs)
	if (locale === "it") return it_follow(inputs)
	if (locale === "pl") return pl_follow(inputs)
	if (locale === "uk") return uk_follow(inputs)
	if (locale === "hi") return hi_follow(inputs)
	if (locale === "ar") return ar_follow(inputs)
	if (locale === "ms") return ms_follow(inputs)
	if (locale === "bn") return bn_follow(inputs)
	if (locale === "zh-TW") return zh_tw2_follow(inputs)
	if (locale === "zh-HK") return zh_hk2_follow(inputs)
	if (locale === "ur") return ur_follow(inputs)
	if (locale === "fa") return fa_follow(inputs)
	if (locale === "sw") return sw_follow(inputs)
	if (locale === "nl") return nl_follow(inputs)
	return en_follow(inputs)
});